import classNames from "classnames";

type SearchInputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const SearchInput = ({
  className,
  ...rest
}: SearchInputProps): JSX.Element => {
  return (
    <input
      type="text"
      css={`
        &.form-control {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'%3E%3Cpath fill='%23555555' fill-rule='evenodd' d='M11.5596 7.33496C11.4365 7.80436 11.2611 8.24414 11.0332 8.6543L10.7529 9.13281L10.4863 9.57031L14 12.6465L13.0977 13.5488L9.58398 10.4727C9.53841 10.5 9.38802 10.5934 9.13281 10.7529C8.8776 10.9124 8.7181 11.0059 8.6543 11.0332C8.24414 11.2611 7.80436 11.4365 7.33496 11.5596C6.86556 11.6826 6.38021 11.7441 5.87891 11.7441C5.06771 11.7441 4.30436 11.5892 3.58887 11.2793C2.87337 10.9694 2.2513 10.5501 1.72266 10.0215C1.19401 9.49284 0.77474 8.87305 0.464844 8.16211C0.154948 7.45117 0 6.6901 0 5.87891C0 5.06771 0.154948 4.30436 0.464844 3.58887C0.77474 2.87337 1.19401 2.2513 1.72266 1.72266C2.2513 1.19401 2.87337 0.77474 3.58887 0.464844C4.30436 0.154948 5.06771 0 5.87891 0C6.68099 0 7.43978 0.154948 8.15527 0.464844C8.87077 0.77474 9.49284 1.19401 10.0215 1.72266C10.5501 2.2513 10.9694 2.87337 11.2793 3.58887C11.5892 4.30436 11.7441 5.06771 11.7441 5.87891C11.7441 6.38021 11.6826 6.86556 11.5596 7.33496ZM1.29199 3.9375C1.03223 4.53906 0.902344 5.1862 0.902344 5.87891C0.902344 6.5625 1.03223 7.20508 1.29199 7.80664C1.55176 8.4082 1.90723 8.93457 2.3584 9.38574C2.80957 9.83691 3.33594 10.1924 3.9375 10.4521C4.53906 10.7119 5.1862 10.8418 5.87891 10.8418C6.5625 10.8418 7.20508 10.7119 7.80664 10.4521C8.4082 10.1924 8.93457 9.83691 9.38574 9.38574C9.83691 8.93457 10.1924 8.4082 10.4521 7.80664C10.7119 7.20508 10.8418 6.5625 10.8418 5.87891C10.8418 5.1862 10.7119 4.53906 10.4521 3.9375C10.1924 3.33594 9.83691 2.81185 9.38574 2.36523C8.93457 1.91862 8.4082 1.56315 7.80664 1.29883C7.20508 1.03451 6.5625 0.902344 5.87891 0.902344C5.1862 0.902344 4.53906 1.03451 3.9375 1.29883C3.33594 1.56315 2.80957 1.91862 2.3584 2.36523C1.90723 2.81185 1.55176 3.33594 1.29199 3.9375Z' clip-rule='evenodd'/%3E%3C/svg%3E%0A");
          background-repeat: no-repeat;
          background-position: 0.75rem 50%;

          padding-left: 2.25rem;

          background-color: #f7f7f7;
          border-color: #f7f7f7;
          color: #555555;

          &:focus {
            background-color: #f7f7f7;
            border-color: #f7f7f7;
            color: #555555;
          }
        }
      `}
      className={classNames("form-control", className)}
      {...rest}
    />
  );
};
